// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../../imageLarge.fragment.generated';
import { QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragmentDoc } from './QuestionnaireQuestionChoiceOptionContentIconCardConditional.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentIconCardFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContentIconCard on QuestionnaireQuestionChoiceOptionContentIconCard {
  __typename
  icon {
    url
    ...imageLarge
  }
  title
  description
  backgroundColor
  conditionalContent {
    ...questionnaireQuestionChoiceOptionContentIconCardConditional
  }
}
    ${ImageLargeFragmentDoc}
${QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragmentDoc}`;